import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import '@fullcalendar/bootstrap5/main.css';
import '@fullcalendar/daygrid/main.css';
//import '@fullcalendar/timegrid/main.css';

import api from '../../../apis/api';
import moment from 'moment';
import Select from 'react-select';
// Static date for consistent display
const todayStr = new Date().toISOString().split('T')[0];
const loginUser = JSON.parse(localStorage.getItem("user"));


const CalenderTask = ({ CalendarYearList, handlecancel, holidaycal }) => {
  const [calendarList, setCalendarList] = useState([]);
  const [leaveDetails, setLeaveDetails] = useState({
    leaveType: "",
    fromDate: "",
    toDate: "",
    reason: ""
  });
  const calendarRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [leaveName, setLeaveName] = useState('');

  const [leaveType, setLeaveType] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [reason, setReason] = useState('');
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [datediff, setdatediff] = useState(0);
  const [fromdutytype, setfromdutytype] = useState("1");
  const [todutytype, settodutytype] = useState("1");
  const [error, setError] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [curRadiobutton, setcurRadiobutton] = useState(0);
  const [isViewtodate, setisViewtodate] = useState(false);
  const [isViewtime, setisViewtime] = useState(false);
  const [leavetype, setleavetype] = useState(1);
  const [leavetypekey, setleavetypekey] = useState("");

  let holidaylist = [];
  if (holidaycal && holidaycal.length > 0) {
    holidaycal.map(function (hol) {
      holidaylist.push(new Date(hol.holidayDate));
    })
  }
  const getPlannedLeaveEvents = async () => {
    try {
      const res = await api.dbCalendarYear().GetAllPlannedLeaveAppply();
      const plannedLeaves = res.data || [];

      const groupByDate = {};

      plannedLeaves.forEach((leave) => {
        const from = moment(leave.fromDate).startOf('day');
        const to = moment(leave.toDate).startOf('day');
        const firstName = leave.employeeName?.split(' ')[0] || '';
        const match = leave.leaveType.match(/\((.*?)\)/);
        const valueInBracket = match ? match[1] : '';
        const leaveDuration =
          leave.fromType == 2 || leave.toType == 2 ? "Half Day" : "Full Day";

        let current = from.clone();

        while (current.isSameOrBefore(to)) {
          const dayOfWeek = current.day(); // 0 = Sunday, 6 = Saturday
          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            const dateStr = current.format("YYYY-MM-DD");

            if (!groupByDate[dateStr]) {
              groupByDate[dateStr] = [];
            }

            groupByDate[dateStr].push({
              id: leave.leaveRequestId,
              employeeName: firstName,
              leaveType: valueInBracket,
              duration: leaveDuration,
              createdBy: leave.createdBy
            });
          }

          current.add(1, "days");
        }
      });

      // Convert grouped data into calendar events
      const allEvents = Object.keys(groupByDate).map((dateStr) => ({
        id: dateStr,
        title: '',
        start: dateStr,
        allDay: true,
        extendedProps: {
          absentees: groupByDate[dateStr],
        },
      }));

      return allEvents;
    } catch (error) {
      console.error("Failed to fetch planned leave data:", error);
      return [];
    }
  };
  const date_diff_indays = function (fromDate, toDate, holidaylist = []) {
    const dt1 = moment(fromDate, ['YYYY-MM-DD', 'DD/MM/YYYY']);
    const dt2 = moment(toDate, ['YYYY-MM-DD', 'DD/MM/YYYY']);

    if (!dt1.isValid() || !dt2.isValid()) {
      return 0; // or handle error
    }

    let count = 0;
    let includesWeekend = false;
    const holidaySet = new Set(holidaylist.map(d => moment(d).format("YYYY-MM-DD")));

    for (let m = moment(dt1); m.isSameOrBefore(dt2); m.add(1, 'days')) {
      const day = m.day(); // 0 = Sunday, 6 = Saturday
      const isWeekend = day === 0 || day === 6;
      const isHoliday = holidaySet.has(m.format("YYYY-MM-DD"));

      if (!isWeekend && !isHoliday) {
        count++;
      }

      if (isWeekend) includesWeekend = true;
    }

    return count; // Just weekdays excluding holidays
  };

  const handleDeleteLeave = async (leaveId, employeeName, leaveType, date) => {
    const confirmText = `Do you want to delete this leave entry?\n\nEmployee: ${employeeName}\nLeave Type: ${leaveType}\nDate: ${moment(date).format("YYYY-MM-DD")}`;

    if (!window.confirm(confirmText)) return;

    try {
      await api.dbCalendarYear().DeletePlannedLeaveApply(leaveId);
      const updatedEvents = await getPlannedLeaveEvents();
      setCalendarEvents(updatedEvents);
    } catch (error) {
      alert("Failed to delete leave entry");
    }
  };
  const setTodatechanes = React.useCallback((todate) => {
    setToDate(todate);
    settodutytype(1);

    if (fromDate !== '') {
      const newdatediff = date_diff_indays(fromDate, todate, holidaylist);

      if (newdatediff <= 0) {
        setError({
          ...error,
          message: "To Date must be greater than From Date",
          status: 500
        });
        setdatediff(0);
      } else {
        setdatediff(newdatediff);
      }
    } else {
      setError({
        ...error,
        message: "To Date must be greater than From Date",
        status: 500
      });
      setdatediff(0);
    }
  }, [fromDate, holidaylist, error, datediff]);


  const setFromdatechanes = React.useCallback((fromdate) => {
    setFromDate(fromdate);
    setfromdutytype(1); // Reset from duty type to full-day

    // Adjust datediff if either From or To duty type is half-day
    if (todutytype == 2 || fromdutytype == 2) {
      setdatediff(datediff - 0.5);
    }

    if (toDate !== '') {
      const newdatediff = date_diff_indays(fromdate, toDate, holidaylist);

      if (newdatediff <= 0) {
        setError({
          ...error,
          message: "To Date must be greater than From Date",
          status: 500
        });
        setdatediff(0);
      } else {
        setdatediff(newdatediff);
      }
    } else {
      // No ToDate selected yet
      setdatediff(0);
    }

  }, [toDate, todutytype, fromdutytype, holidaylist, datediff, error]);


  const handleonchangeFromduetytype = React.useCallback((type) => {
    setfromdutytype(type);
    if (fromDate && toDate) {
      let newdatediff = date_diff_indays(fromDate, toDate, holidaylist);
      if (parseInt(type) == 2 || parseInt(todutytype) == 2) {
        newdatediff -= 0.5;
      }
      setdatediff(newdatediff);
    }
  }, [fromDate, toDate, todutytype, holidaylist]);
  const handleonchangeToduetytype = React.useCallback((type) => {
    settodutytype(type);
    if (fromDate && toDate) {
      let newdatediff = date_diff_indays(fromDate, toDate, holidaylist);
      if (parseInt(type) == 2 || parseInt(fromdutytype) == 2) {
        newdatediff -= 0.5;
      }
      setdatediff(newdatediff);
    }
  }, [fromDate, toDate, fromdutytype, holidaylist]);
  const toggleradiobutton = (e) => {
    setcurRadiobutton(e);
    if (e == 1) {
      setisViewtodate(false);
      setisViewtime(true);

    }
    else if (e == 2) {
      setisViewtodate(false);
      setisViewtime(false);
    }
    else {
      setisViewtodate(true);
      setisViewtime(false);
    }

  }
  const handleonchangeduetytype = (e, key) => {
    setleavetype(e);
    setleavetypekey(key);
    if (e == '79') {
      setFromDate(new Date());
      setToDate(new Date());
    }
  }


  useEffect(() => {
    setCalendarList(CalendarYearList || []);
  }, [CalendarYearList]);

  const handleDateClick = (arg) => {
    setSelectedDate(arg.dateStr);
    setFromDate(arg.dateStr);
    setToDate(arg.dateStr);
    setReason("");
    setSelectedLeaveType("");
    setSelectedEmployee("");
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    // Reset all form states
    setSelectedDate('');
    setSelectedEmployee('');
    setSelectedLeaveType('');
    setFromDate('');
    setToDate('');
    setReason('');
    setfromdutytype("1");
    settodutytype("1");
    setdatediff(0);
    setcurRadiobutton(0);
    setError(null);

    handlecancel && handlecancel();
  };

  const handleAddLeave = async () => {
    if (!selectedEmployee) {
      alert("Please select an employee.");
      return;
    }
    if (!selectedLeaveType) {
      alert("Please select a leave type.");
      return;
    }
    if (!fromDate || !toDate) {
      alert("Please select both From and To dates.");
      return;
    }
    if (new Date(fromDate) > new Date(toDate)) {
      alert("From date cannot be after To date.");
      return;
    }
    if (!reason || reason.trim() === "") {
      alert("Please provide a reason for leave.");
      return;
    }

    try {
      const payload = {
        EmployeeId: Number(selectedEmployee),
        LeaveTypeId: Number(selectedLeaveType),
        FromDate: moment(fromDate).format("YYYY-MM-DD"),
        ToDate: moment(toDate).format("YYYY-MM-DD"),
        FromType: String(fromDate === toDate ? fromdutytype : "1"),
        ToType: String(fromDate === toDate ? todutytype : "1"),
        DaysCount: datediff,
        Reason: reason,
        CreatedBy: loginUser.EmployeeName,
        UpdatedBy: loginUser.EmployeeName,
      };
      const response = await api.dbCalendarYear().AddEditPlannedLeaveApply(payload);

      setShowModal(false);
      const updatedEvents = await getPlannedLeaveEvents();
      setCalendarEvents(updatedEvents);
    } catch (error) {
      console.error("Error applying leave", error);
    }
  };

  const renderEventContent = (eventInfo) => {
    const absentees = eventInfo.event.extendedProps.absentees || [];
    const dateOfCell = eventInfo.event.start;

    return (
      <div style={{ fontSize: '0.75rem', whiteSpace: 'normal' }}>
        {absentees.map((emp, idx) => (
          <div
            key={idx}
            className="d-flex justify-content-between align-items-center text-danger fw-semibold"
          >
            <span>{`${emp.employeeName} (${emp.leaveType} ${emp.duration})`}</span>
            {loginUser != null ? emp.createdBy === loginUser.EmployeeName && (
              <i
                className="bi bi-trash text-danger ms-2"
                style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteLeave(emp.id, emp.employeeName, emp.leaveType, dateOfCell);
                }}
              />
            ) : null}
          </div>
        ))}
      </div>
    );
  };
  const handleMarkLeaveClick = async () => {
    setSelectedDate(new Date().toISOString().split('T')[0]); // Default today
    setSelectedEmployee('');
    setSelectedLeaveType('');
    setFromDate('');
    setToDate('');
    setReason('');
    setfromdutytype("1");
    settodutytype("1");
    setdatediff(0);
    setcurRadiobutton(0);
    setError(null);
    setShowModal(true);

    try {
      const res = await api.task().GetEmployeeBasedOnLeaveAssignedEmpId(parseInt(loginUser.EmployeeId));
      const empData = res.data || [];
      const activeEmployees = empData.filter(emp => emp.isActive === true);
      const empOptions = activeEmployees.map(emp => ({ value: emp.employeeId, label: emp.employeeName }));
      setEmployeeList(empOptions);
    } catch (error) {
      console.error("Failed to fetch employees:", error);
    } 
  };

  

  useEffect(() => {
    const loadCalendarData = async () => {
      const events = await getPlannedLeaveEvents();
      setCalendarEvents(events);
    };
    loadCalendarData();
  }, []);

  return (
    <div className="container-fluid my-5 px-0">
      <div className="row">
        <div className="col-12">
          <div className="card shadow border-0 mx-auto" style={{ maxWidth: '1000px' }}>
            <div className="absence-calendar-title" style={{ backgroundColor: '#222020d3', padding: '10px', color: 'white' }}>
              Employee Absence Calendar
            </div>
            <div className="card-body px-4 py-4">
              <div className="table-responsive">
                <FullCalendar
                  ref={calendarRef}
                  plugins={[dayGridPlugin, bootstrap5Plugin]}
                  themeSystem="bootstrap5"
                  initialView="dayGridMonth"
                  events={calendarEvents} // ✅ use state-based events
                  allDaySlot={true}
                  eventContent={renderEventContent} // ✅ Required to show names
                  dateClick={handleDateClick}
                  dayMaxEvents={true}
                  dayMaxEventRows={true}
                  height="auto"
                  aspectRatio={1.6}
                  headerToolbar={{
                    left: 'markLeaveButton',
                    center: 'title',
                    right: 'today customPrev customNext',
                  }}

                  customButtons={{
                    markLeaveButton: {
                      text: 'Mark Leave',
                      click: handleMarkLeaveClick, // ✅ updated handler
                    },
                    customPrev: {
                      text: '',
                      click: () => calendarRef.current.getApi().prev(),
                    },
                    customNext: {
                      text: '',
                      click: () => calendarRef.current.getApi().next(),
                    },
                  }}
                  buttonIcons={false}
                  buttonText={{ today: 'Today' }}
                />
              </div>

              {/* Modal */}
              {showModal && (
                <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Mark Leave</h5>
                      </div>

                      <div className="modal-body">
                        {/* Employee Select */}
                        <div className="mb-3">
                          <Select
                            classNamePrefix="react-select"
                            value={employeeList.find(emp => emp.value === selectedEmployee) || null}
                            onChange={async (option) => {
                              const empId = option?.value || "";
                              setSelectedEmployee(empId);
                              setLeaveName(option?.label || "");

                              if (empId) {
                                try {
                                  const resLeave = await api.dbLeaveTypes().GetLeaveTypesByEmpId(parseInt(empId));
                                  const leaveData = resLeave.data || [];
                                  const leaveOptions = leaveData.map(lt => ({
                                    value: lt.leaveTypeId,
                                    label: lt.type
                                  }));
                                  setLeaveTypeList(leaveOptions);
                                } catch (error) {
                                  console.error("Error fetching leave types by employee:", error);
                                }
                              } else {
                                setLeaveTypeList([]); // reset if no employee selected
                              }
                            }}
                            options={employeeList}
                            isSearchable={true}
                            placeholder="Select Employee"
                            filterOption={(option, inputValue) =>
                              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
                            }
                          />
                        </div>

                        {/* Leave Type Select */}
                        <div className="mb-3">
                          <Select
                            classNamePrefix="react-select"
                            value={leaveTypeList.find(lt => lt.value === selectedLeaveType) || null}
                            onChange={(option) => setSelectedLeaveType(option?.value || "")}
                            options={leaveTypeList}
                            isSearchable={true}
                            placeholder="Select Leave Type"
                            filterOption={(option, inputValue) =>
                              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
                            }
                          />
                        </div>

                        {/* From Date & To Date */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label htmlFor="fromDate" className="form-label">From Date</label>
                            <input
                              type="date"
                              id="fromDate"
                              className="form-control"
                              value={fromDate}
                              onChange={(e) => setFromdatechanes(e.target.value)}
                            />
                          </div>

                          <div className="col-md-6">
                            <label htmlFor="toDate" className="form-label">To Date</label>
                            <input
                              type="date"
                              id="toDate"
                              className="form-control"
                              value={toDate}
                              onChange={(e) => setTodatechanes(e.target.value)}
                              min={fromDate || undefined}
                            />
                          </div>
                        </div>

                        {/* Type & Working Days */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label htmlFor="fromType" className="form-label">Type</label>
                            <select
                              id="fromType"
                              className="form-control"
                              value={fromdutytype}
                              onChange={(e) => handleonchangeFromduetytype(e.target.value)}
                              disabled={fromDate !== toDate}
                              style={{ backgroundColor: fromDate !== toDate ? '#e9ecef' : '' }}
                            >
                              <option value="1">Full Day</option>
                              <option value="2">Half Day</option>
                            </select>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Working Days</label>
                            <input
                              type="text"
                              className="form-control bg-light"
                              readOnly
                              value={
                                curRadiobutton === 1
                                  ? 0.5
                                  : curRadiobutton === 2
                                    ? 1
                                    : datediff === 0
                                      ? 0
                                      : datediff
                              }
                            />
                          </div>
                        </div>

                        {/* Reason */}
                        <div className="mb-3">
                          <textarea
                            className="form-control"
                            placeholder="Enter Reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleAddLeave}>
                          Mark Leave
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Styling overrides */}
              <style>{`
              
    .fc .fc-button,
  .fc .fc-button-primary {
    background-color: #222020d3 !important;
    border-color: #222020d3 !important;
    color: white !important;
    font-weight: 500;
    border-radius: 6px;
    padding: 6px 12px;
  }

  /* ✅ Add specific styles for Today button */
  .fc-today-button {
    background-color: #0c3747 !important;
    border-color: #0c3747 !important;
    color: white !important;
  }

  /* ✅ Style custom buttons too */
  .fc-customPrev-button,
  .fc-customNext-button,
  .fc-markLeaveButton-button {
    background-color: #0c3747 !important;
    border-color: #0c3747 !important;
    color: white !important;
  }

  /* Hover effect */
  .fc .fc-button:hover {
    background-color: #3a3a3a !important;
  }

  .absence-calendar-title {
  font-size: 1.5rem;      /* Increase size */
  font-weight: bold;      /* Optional: make it bold */
  text-align: center;     /* Center the text */
  margin-bottom: 1rem;    /* Spacing below title */
}
                .fc {
                  font-size: 1rem;
                }
                .fc-event {
                  background-color: transparent !important;
                  border: none !important;
                  box-shadow: none !important;
                  padding: 2px 0 !important;
                  margin: 0 !important;
                }
                .fc-daygrid-event-harness {
                  background-color: transparent !important;
                }
                .fc-event-title,
                .fc-event-time {
                  display: none !important;
                }
                .fc-daygrid-day-number {
                  font-size: 1rem;
                  font-weight: 400;
                }
                .fc-daygrid-day-frame {
                  padding: 8px !important;
                }
                    .fc-day-today {
                 background-color: transparent !important;
              }
                .fc-col-header-cell {
                  font-size: 1.05rem;
                  font-weight: 500;
                  padding: 10px 0;
                }
                .fc-customPrev-button::before {
                  content: '\\f284';
                  font-family: 'bootstrap-icons';
                  font-size: 1.2rem;
                  margin-right: 4px;
                }
                .fc-customNext-button::before {
                  content: '\\f285';
                  font-family: 'bootstrap-icons';
                  font-size: 1.2rem;
                  margin-right: 4px;
                }
              `}</style>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalenderTask;